import Modal from "@/components/Modal"
import React from "react"
import Link from "next/link"
import TextCopy from "@/components/TextCopy"
import { usePromptInputStore } from "@/stores"

const SuggestPromptModal = () => {
  const { promptInput, setPromptInput } = usePromptInputStore()

  const handleClose = () => {
    setPromptInput(null)
  }

  return (
    <Modal
      title={"Suggested Prompts"}
      isOpen={promptInput?.modalType === "SuggestPromptModal"}
      onClose={handleClose}
      bodyClassName="overflow-hidden p-0"
      className="relative w-full max-w-6xl overflow-hidden rounded-2xl bg-atherGray-900"
      containerClassName={"md:backdrop-blur-xl overflow-hidden"}
    >
      <p className="mb-4 text-atherGray-300">
        Describe what you want to generate. Learn more about the structure and examples{" "}
        <Link className="underline" href="/tips-and-tricks/prompt-book?lang=en" target="_blank">
          here
        </Link>
        .{" "}
      </p>
      <p className="text-atherGray-300 mb-2">Here are some quick examples for you</p>
      <div className="grid grid-cols-[repeat(auto-fit,minmax(20rem,_1fr))] gap-6">
        {promptInput?.examples?.map((example, index) => (
          <div
            key={index}
            className="flex items-start bg-atherGray-950 p-2 rounded-lg cursor-pointer"
            onClick={() => {
              promptInput?.onChange(example)
              handleClose()
            }}
          >
            <div className="flex items-start flex-wrap gap-1">
              {example &&
                example.split(",").map((item, index) => (
                  <span
                    key={index}
                    className="text-atherGray-300 flex items-center text-sm border border-atherGray-700 py-0.5 px-2 font-normal rounded-lg"
                  >
                    {item}
                    <TextCopy className="ml-1" value={item} />
                  </span>
                ))}
            </div>
          </div>
        ))}
      </div>
    </Modal>
  )
}

export default SuggestPromptModal
